/** Admin: an owner's hardware order history (owner-twin, read). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import OrderHistory from '../../../../owner/shop/orders';

export default function AdminOwnerShopOrdersScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <OrderHistory />
    </OwnerScopeProvider>
  );
}
